import React, { useMemo } from 'react'

import BaseInfoCard from '../BaseInfoCard'
import NoData from '../BaseInfoCard/NoData'
import Loading from 'components/Loading'
import _ from 'lodash'

import useMyHealthPolicyByModel from 'hooks/useMyHealthPolicy'

import { parseTestResults } from 'helpers/parseEnhanced'
import ResultItem from './TestResultItem'
import { useTheme } from 'contexts/ThemeProvider'
import SthWentWrong from 'containers/MyHealth/components/MyHealthContentArea/SthWentWrong'

const Medications = (props) => {
  const { isDark } = useTheme()
  const {
    loading, data, linkTo, name, error
  } = props
  const icon = isDark ? props.iconDark : props.icon
  const iconGray = isDark ? props.iconGrayDark : props.iconGray

  const groupedTests = useMemo(() => parseTestResults(data), [data])

  const sthStyle = { backgroundColor: 'transparent', height: '100%' }

  const sortByCode = results => {
    return _.orderBy(results, ['code'], ['asc'])
  }

  const testsInfoGroupedByDates = useMemo(() => {
    const sortedResult = Object.values(groupedTests).map(test => sortByCode(test))
    const flatResult = _.flatten(Object.values(sortedResult))
    const results = flatResult.filter(item => {
      return item.result !== null && item.result !== ''
    })
    return results.slice(0, 2)
  }, [groupedTests])

  const adolescent = !useMyHealthPolicyByModel('testResults')

  return (
    <BaseInfoCard title={name} icon={icon} linkTo={linkTo}>
      {adolescent && <NoData />}
      {!adolescent && loading && _.isEmpty(testsInfoGroupedByDates) && <Loading />}
      {!adolescent && (!_.isEmpty(testsInfoGroupedByDates)
        ? testsInfoGroupedByDates.map((test, index) => {
          const res = {
            [test.date]: test
          }
          return <ResultItem key={index} test={res} iconGray={iconGray} isLast={index === testsInfoGroupedByDates.length - 1} />
        })
        : error ? <SthWentWrong style={{ container: sthStyle }} /> : <NoData text={name} />)}
    </BaseInfoCard>
  )
}

export default Medications
